<div class="customers-summary">
  <div *ngIf="selection?.length !== 1" class="arm-summary">{{selection?.length || 0}} Items selected</div>
  <div *ngIf="selection?.length === 1" class="arm-summary">
    <div fxLayout="row" class="arm-summary-item">
      <span class="arm-summary-name">Name:</span>
      <span class="arm-summary-value" [matTooltip]="selection[0].name">{{selection[0].name}}</span>
    </div>
    <div fxLayout="row" class="arm-summary-item">
      <span class="arm-summary-name">CAC State:</span>
      <span class="arm-summary-value" [matTooltip]="selection[0].cacState">{{selection[0].cacState}}</span>
    </div>
    <div fxLayout="row" class="arm-summary-item">
      <span class="arm-summary-name">Admin state:</span>
      <span class="arm-summary-value" [matTooltip]="selection[0].adminState">{{selection[0].adminState}}</span>
    </div>
    <div fxLayout="row" class="arm-summary-item">
      <span class="arm-summary-name">Prefix Groups:</span>
      <span class="arm-summary-value" [matTooltip]="selection[0].attributeGroupsNames">{{selection[0].attributeGroupsNames}}</span>
    </div>
    <div fxLayout="row" class="arm-summary-item">
      <span class="arm-summary-name">Policy Studio Tag:</span>
      <span class="arm-summary-value" [matTooltip]="selection[0].tag">{{selection[0].tag}}</span>
    </div>
    <div fxLayout="row" class="arm-summary-item">
      <span class="arm-summary-name">SIP Header Name:</span>
      <span class="arm-summary-value" [matTooltip]="selection[0].sipHeaderName">{{selection[0].sipHeaderName}}</span>
    </div>
    <div fxLayout="row" class="arm-summary-item">
      <span class="arm-summary-name">SIP Header Value:</span>
      <span class="arm-summary-value" [matTooltip]="selection[0].sipHeaderValue">{{selection[0].sipHeaderValue}}</span>
    </div>
    <div fxLayout="row" class="arm-summary-item">
      <span class="arm-summary-name">CAC Profile:</span>
      <span class="arm-summary-value" [matTooltip]="selection[0].cacProfileName">{{selection[0].cacProfileName}}</span>
    </div>
  </div>
</div>
